module.exports = __webpack_public_path__ + "static/media/slide-earning-on.db3703c2.png";